var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "fill-place" },
    [
      _c(
        "div",
        {
          staticClass: "person-info",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _setup.fill_click.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "person-info__content",
              class: { _error: _setup.shouldShowError },
            },
            [
              _c("div", { staticClass: "person-info__booking" }, [
                _vm._v(
                  "               \n                " +
                    _vm._s(_setup.place_label) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "person-info__service-icon" },
                [
                  _setup.shouldShowError
                    ? _c(_setup.vWarning, { staticClass: "icon vicon-orange" })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "person-info__name" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_setup.person_names.fio) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _setup.person_names.born || _setup.person_names.male
                ? _c("div", { staticClass: "person-info__sign" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_setup.person_names.born) +
                        _vm._s(_setup.person_names.born ? ", " : "") +
                        _vm._s(_setup.person_names.male) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _setup.person_names.doc_type || _setup.person_names.doc_num
                ? _c("div", { staticClass: "person-info__docs" }, [
                    _c(
                      "div",
                      { staticClass: "person-info__docs-icon" },
                      [_c(_setup.docIcon, { tag: "component" })],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "person-info__docs-type" }, [
                      _vm._v(_vm._s(_setup.person_names.doc_type)),
                    ]),
                    _vm._v(" "),
                    _setup.person_names.doc_num
                      ? _c("div", { staticClass: "person-info__docs-num" }, [
                          _vm._v(_vm._s(_setup.person_names.doc_num)),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _setup.shouldShowError
            ? _c("div", { staticClass: "person-info__errors" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _setup.person_names.isValid
                        ? "Корректно"
                        : "Необходимо заполнить всю информацию"
                    ) +
                    "\n        "
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _setup.wasClick
        ? [
            _c(
              _setup.Modal,
              {
                attrs: {
                  enableClose: false,
                  title: "",
                  "modal-class": "fill-modal",
                  "wrapper-class": "animate__animated",
                  "in-class": "animate__zoomIn hideScroll",
                  "out-class": "animate__zoomOut hideScroll",
                },
                model: {
                  value: _setup.isModalShown,
                  callback: function ($$v) {
                    _setup.isModalShown = $$v
                  },
                  expression: "isModalShown",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "fill-modal__header fill-modal-header" },
                  [
                    _c(
                      _setup.ModalTitle,
                      {
                        staticClass: "fill-modal-header__title",
                        on: { close: _setup.close_click },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_setup.ModalTitleName) +
                            " "
                        ),
                        _c("span", { staticClass: "fill-modal-header__id" }, [
                          _vm._v(_vm._s(_setup.personItem.sid)),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "fill-modal-header__content" }, [
                      _vm._v(
                        "\n                    Пожалуйста, заполните все поля\n                "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "personRef", staticClass: "fill-modal__content" },
                  [
                    _c(_setup.Person, {
                      attrs: {
                        sid: _setup.personItem.sid,
                        copy_person_list: _setup.copy_person_list,
                        copy_person_button: _setup.isCustomer()
                          ? "Сделать заказчиком"
                          : "Внести данные",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "fill-modal__footer fill-modal-footer" },
                  [
                    _c(
                      "div",
                      { staticClass: "fill-modal-footer__info" },
                      [
                        _c(_setup.PersonEmptyFields, {
                          staticClass: "fill-modal-footer__empty",
                          attrs: {
                            sid: _setup.personItem.sid,
                            personRef: _setup.personRef,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "fill-modal-footer__clear-all",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _setup.clear_all.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Очистить форму")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "fill-modal-footer__controls" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--bluefigma",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _setup.close_click.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Сохранить данные")]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }